var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._g({attrs:{"data-test":"ruble-icon","data-qa":"ruble-icon"},domProps:{"innerHTML":_vm._s(_vm.innerHtml)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }